import React, { Component } from 'react';
import { numberParce } from '../../../server/util';
import PropTypes from 'prop-types';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import NotificationSystem from 'react-notification-system';
import './studentDetails.css'
class StudentDetails extends Component {
    constructor(props){
        super(props);
        this.state={
            tabIndex: 0,
            id:0,
            data:{}

        }
    }
    componentDidMount=()=>{
        this._notificationSystem = this.refs.notificationSystem;
    }
    componentWillMount=()=>{     
        this.props.changeShowHideSchoolFitler(false);   
        const _id=numberParce(this.context.router.route.match.params.id);
        const data=(this.context.router.route.location.state||{}).data||{}
        if(_id>0){
            this.setState({id:_id, data:data});
        }
    }
    render() {
        const {data}=this.state;
        const {record, schoolObj}=data;
        return (
            <div>
                <NotificationSystem ref="notificationSystem"/>
                <section>
                    <div className="container">
                        <div className="sectionTitle">
                            <h2>
                                <span>Student Profile</span>
                            </h2>
                        </div>
                        <div className="emp-profile">                            
                            <div className='row'>
                                <div className="col-md-4">
                                    <div className="profile-img">
                                        <img src={record.image} alt=""/>
                                       {/*  <div className="file btn btn-lg btn-primary">
                                            Change Photo
                                            <input type="file" name="file"/>
                                        </div> */}
                                    </div>
                                </div>
                                <div className="col-md-6">
                                    <div className="profile-head">
                                        <h5>
                                            {`${record.lastName} ${record.firstName}`}
                                        </h5>                                        
                                        <h6>
                                            {`${'Grade'} : ${record.gradeName}`}
                                        </h6>
                                        <p className="proile-rating">School : <span>{`${((schoolObj[record.mSchoolId]||[])[0]||{}).schoolName||''}`}</span></p>
                                        {/* <Tabs>
                                            <TabList>
                                                 <Tab onClick={() => {
                                                    this.setState({tabIndex:0})
                                                }}>About</Tab> 
                                                <Tab onClick={() => {
                                                    this.setState({tabIndex:1})
                                                }}>Other Info</Tab>
                                            </TabList>
                                            <TabPanel> */}
                                                <table className='table table-responsive table-bordered'>
                                                    <tbody>
                                                    <tr><td>Teacher :</td><td>{record.teacherName}</td></tr>
                                                    <tr><td>Pin</td><td>{record.pin}</td></tr>
                                                    <tr><td>Eligible for:</td><td>{record.isFreeMealEligible? 'Free Lunch': record.isReducePriceEligible? 'Reduced Price':'Regular Price'}</td></tr>
                                                    <tr><td>Account Balance</td><td>{record.accBalance}</td></tr>
                                                    </tbody>
                                                </table>
                                           {/*  </TabPanel>
                                        </Tabs> */}
                                    </div>
                                </div>
                                <div className="col-md-2">
                                    <button className='btn btn-sm btn-warning' onClick={()=>{
                                        this.context.router.history.push(`/district/manageStudents`);
                                    }}>Back</button>
                                    {/* <input type="submit" className="profile-edit-btn" name="btnAddMore" value="Edit Profile"/> */}
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-md-4">
                                    <div className="profile-work" style={{marginTop: '-10%'}}>
                                        <a>{`Student Id : ${record.studentId}`}</a><br/>
                                        <a>{`Email : ${record.parentuser.userName}`}</a><br/>
                                        <a>{`Mobile : ${record.mobileNo}`}</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
        );
    }
}
StudentDetails.contextTypes = {
    router: PropTypes.object.isRequired
}
export default StudentDetails;


// WEBPACK FOOTER //
// ./src/components/District/manageStudents/studentDetails.jsx